
export const financialConstants = {

  getFinancialRequest: "FINANCIAL/GET_REQUEST",
  getFinancialSuccess: "FINANCIAL/GET_SUCCESS",
  getFinancialFailure: "FINANCIAL/GET_FAILURE",

  createPaymentRequest: "FINANCIAL/CREATE_PAYMENT_REQUEST",
  updatePaymentRequest: "FINANCIAL/UPDATE_PAYMENT_REQUEST",
  deletePaymentRequest: "FINANCIAL/DELETE_PAYMENT_REQUEST",

  createExpenseRequest: "FINANCIAL/CREATE_EXPENSE_REQUEST",
  updateExpenseRequest: "FINANCIAL/UPDATE_EXPENSE_REQUEST",
  deleteExpenseRequest: "FINANCIAL/DELETE_EXPENSE_REQUEST",

  createPayoutRequest: "FINANCIAL/CREATE_PAYOUT_REQUEST",
  updatePayoutRequest: "FINANCIAL/UPDATE_PAYOUT_REQUEST",
  deletePayoutRequest: "FINANCIAL/DELETE_PAYOUT_REQUEST",

  createFinancialAlertRequest: "FINANCIAL/CREATE_FINANCIAL_ALERT_REQUEST",
  updateFinancialAlertRequest: "FINANCIAL/UPDATE_FINANCIAL_ALERT_REQUEST",
  deleteFinancialAlertRequest: "FINANCIAL/DELETE_FINANCIAL_ALERT_REQUEST",

  createExpenseContactRequest: "FINANCIAL/CREATE_EXPENSE_CONTACT_REQUEST",
  updateExpenseContactRequest: "FINANCIAL/UPDATE_EXPENSE_CONTACT_REQUEST",
  deleteExpenseContactRequest: "FINANCIAL/DELETE_EXPENSE_CONTACT_REQUEST",

  setFinancialView: "FINANCIAL/SET_VIEW",
  clearFinancialState: "FINANCIAL/CLEAR_STATE",
};
